import { render, staticRenderFns } from "./fusion.vue?vue&type=template&id=a5dea930&"
import script from "./fusion.vue?vue&type=script&lang=js&"
export * from "./fusion.vue?vue&type=script&lang=js&"
import style0 from "./fusion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports